export default "__VITE_ASSET__82f4f6b2__"